const config = {
  API_URL: process.env.REACT_APP_API_URL,
  encrpytionKey: "ab12cd34ef56gh78ij90kl01mn23op45",
  adm1: "rsmilic87@gmail.com",
  adm2: "nedim.rifatbegovic@gmail.com",
  adm3: "test@mail.com",
};

export default config;
